import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { env } from "@/config/env";
import authenticatedApi from "@/lib/api/client";

const BASE_URL = env.VITE_BASE_API_URL;

const downloadZipFile = async (configUrl: string): Promise<void> => {
  const { token } = await authenticatedApi
    .url(`/my-files/download/bulk/folder${configUrl}`)
    .get()
    .json<{ token: string }>();

  const link = document.createElement("a");

  link.href = `${BASE_URL}/api/v1/my-files/download/bulk/from-token?token=${token}`;

  document.body.append(link);
  link.click();
  link.remove();
};

export function useDownloadFolder() {
  const [customError, setCustomError] = useState({ message: "" });

  return {
    ...useMutation({
      mutationFn: async (configUrl: string) => {
        await downloadZipFile(configUrl);
      },
      onError: async (error) => {
        if (error.message.includes("No files found")) {
          setCustomError({ message: "No files found" });
        }
      },
    }),
    error: customError,
  };
}
